import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import {
  BAREME_TVA_PAR_DEFAUT,
  BaremeTvaInvalideError,
  resoudreBaremeTva,
  type TauxTvaDate,
} from '@domain/fiscalite/BaremeTva';
import { logger } from '@infra/telemetry/Logger';

const KEY = 'compta.bareme_tva';

/** Barème de TVA de l'entreprise (lignes datées ajoutées aux défauts) ; valeur invalide : défauts, journalisé. */
export async function loadBaremeTva(tenantId: string): Promise<readonly TauxTvaDate[]> {
  const raw = await SecureTenantStore.getJson<unknown>(tenantId, KEY, []);
  if (!Array.isArray(raw)) return BAREME_TVA_PAR_DEFAUT;
  try {
    return resoudreBaremeTva(raw as TauxTvaDate[]);
  } catch (err) {
    if (!(err instanceof BaremeTvaInvalideError)) throw err;
    logger.warn({ event: 'bareme_tva_invalide', message: err.message });
    return BAREME_TVA_PAR_DEFAUT;
  }
}

/** Enregistre les lignes datées ajoutées par l'entreprise (validées avant écriture). */
export async function saveBaremeTva(
  tenantId: string,
  ajouts: readonly TauxTvaDate[],
): Promise<readonly TauxTvaDate[]> {
  const bareme = resoudreBaremeTva(ajouts);
  await SecureTenantStore.setJson(tenantId, KEY, ajouts);
  return bareme;
}
